/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Bank,
    BankFromJSON,
    BankFromJSONTyped,
    BankToJSON,
    PaymentAdditionalType,
    PaymentAdditionalTypeFromJSON,
    PaymentAdditionalTypeFromJSONTyped,
    PaymentAdditionalTypeToJSON,
    PaymentBaseType,
    PaymentBaseTypeFromJSON,
    PaymentBaseTypeFromJSONTyped,
    PaymentBaseTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaymentTypesResponse
 */
export interface PaymentTypesResponse {
    /**
     * 
     * @type {Array<PaymentBaseType>}
     * @memberof PaymentTypesResponse
     */
    basic: Array<PaymentBaseType>;
    /**
     * 
     * @type {Array<PaymentAdditionalType>}
     * @memberof PaymentTypesResponse
     */
    additional: Array<PaymentAdditionalType>;
    /**
     * 
     * @type {Array<Bank>}
     * @memberof PaymentTypesResponse
     */
    banks: Array<Bank>;
}

export function PaymentTypesResponseFromJSON(json: any): PaymentTypesResponse {
    return PaymentTypesResponseFromJSONTyped(json, false);
}

export function PaymentTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentTypesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'basic': ((json['basic'] as Array<any>).map(PaymentBaseTypeFromJSON)),
        'additional': ((json['additional'] as Array<any>).map(PaymentAdditionalTypeFromJSON)),
        'banks': ((json['banks'] as Array<any>).map(BankFromJSON)),
    };
}

export function PaymentTypesResponseToJSON(value?: PaymentTypesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'basic': ((value.basic as Array<any>).map(PaymentBaseTypeToJSON)),
        'additional': ((value.additional as Array<any>).map(PaymentAdditionalTypeToJSON)),
        'banks': ((value.banks as Array<any>).map(BankToJSON)),
    };
}


